IREP.homePage = (function () {
    var init = function () {
        //   $('.curtains>div').css('position', 'relative');

        $("#contactUs").appendTo("#contentContainer").css({ "position": "fixed", "bottom": "0", "margin": "0" });


        $('.curtains').curtain({
            controls: '.menu'
        });


        var numItems = $('.curtains').children().length;

        if (numItems > 1) {
            $("#footer").appendTo("section:last").css({ "position": "absolute", "bottom": "0", "margin": "0" });
        }
        else {

            $("#footer").appendTo("body").css({ "position": "fixed", "bottom": "0", "margin": "0" });

            $('#subBanner').css({ bottom: '115px' });
            $(".downPager").remove();

        }


        $(function () {
            if ($('#videowrapper').length)         // use this if you are using id to check
            {
                PlayHideVideo('videowrapper', 'video', 'video_01');
                // it exists
            }
        });

        $('#videowrapperDivBR').click(function (e) {
            e.preventDefault();
            $('#videowrapperButton').fadeIn();
            PlayHideVideo('videowrapperButton', 'videoButton', 'video_02');

        });

        $(document).mouseup(function (e) {
            if ($("#videowrapper").css('display') === 'block') {
                var container = $("#video");

                if (!container.is(e.target) // if the target of the click isn't the container...
                    && container.has(e.target).length === 0) // ... nor a descendant of the container
                {

                    $("#videowrapper").fadeOut();
                    PauseFile('video_01');
                }
            }
        });
    };


    var PlayHideVideo = function (videoWrapper, videoDiv, videoPlayer) {
        var myElem = document.getElementsByClassName('curtains');
        if (myElem != null) {
            PlayFile(videoDiv, videoPlayer);
            var player_name = _V_('#' + videoPlayer);
            $(player_name).ready(function () {
                player_name.on('ended', function () {
                    $("#" + videoWrapper).fadeOut();
                });
            });
        }
    }

    var PlayFile = function (videoDiv, videoPlayer) {
        var myPlayer = videojs(videoPlayer);
        myPlayer.play();

        var $window = $(window);
        var windowsize = $window.width();
        if (windowsize < 1400) {
            //if the window is greater than 440px wide then turn on jScrollPane..
            myPlayer.width(640).height(360);
            $("#" + videoDiv).addClass("smallVideo");
        }
        else {
            myPlayer.width(1280).height(720);

            $("#" + videoDiv).removeClass("smallVideo");
        }
    };

    var PauseFile = function (videoPlayer) {
        var myPlayer = videojs(videoPlayer);
        myPlayer.pause();
    };

    return {
        init: init
    };
})();

IREP.homePageMainBanner = (function () {
    var isLoading = false; /* Flag if the current home page banner is currently loading, for slow loads */

    var init = function () {

        TweenMax.to($('.bannerSlider:first'), .4, { autoAlpha: 1, onComplete: showMe, onCompleteParams: [$('.bannerSlider:first')] });


        $(".bannerNext").click(function () {
            rotateBanners();
        });

        $(".bannerPrev").click(function () {

            if (!isLoading) {
                isLoading = true;
                var show = $('.bannerSlider:visible').prev(".bannerSlider:hidden");
                var hide = $('.bannerSlider:visible');
                // alert(test.html());
                if (typeof show.html() === "undefined") {
                    show = $('.bannerSlider:last');
                }

                show.css({ "background-size": "cover", "background-repeat": "no-repeat" });
                if (show.css('background-image') == "none" || show.css('background-image') == null || show.css('background-image') == undefined) {
                    $('<img/>').attr('src', show.attr('data-bgitem')).load(function () {
                        show.css("background-image", "url('" + show.attr('data-bgitem') + "')");

                        playTimeline(hide, show);
                        isLoading = false;
                    });
                }
                else {
                    playTimeline(hide, show);
                    isLoading = false;
                }
            }
        });

        var intervalId = setInterval(rotateBanners, 10000);
        $(".bannerPrev, .bannerNext, bannerItem").hover(
            function () {
                window.clearInterval(intervalId);
            },
            function () {
                intervalId = setInterval(rotateBanners, 10000);
            }
        );



    }

    var hideMe = function ($me) {
        $me.css("display", "none");
    }

    var showMe = function ($me) {
        $me.css({ "display": "table", "background-size": "cover", "background-repeat": "no-repeat"  });

        isLoading = true;
        $('<img/>').attr('src', $me.attr('data-bgitem')).load(function () {
            $me.css("background-image", "url('" + $me.attr('data-bgitem') + "')");
            isLoading = false;
        });

        var test = ($("#subBanner").offset().top - $me.find(".bannerItem").height()) / 2;

        $(".bannerHolder").animate({ top: test - 20 }, 200);

    }
    var playTimeline = function (hide, show) {
        var tl = new TimelineMax();
        tl.insert(new TweenMax(hide, .4, { autoAlpha: 0, display: 'none' }), 0);
        tl.insert(new TweenMax(show, 1, { autoAlpha: 1, display: 'table' }), .4);
        tl.play();
    }

    var rotateBanners = function () {
        if (!isLoading) {
            isLoading = true;
            var show = $('.bannerSlider:visible').nextAll(".bannerSlider:hidden").first();
            var hide = $('.bannerSlider:visible:first');

            if (typeof show.html() === "undefined") {
                $('.bannerSlider').hide();
                show = $('.bannerSlider:first');
            }

            show.css({ "background-size": "cover", "background-repeat": "no-repeat"  });
            if (show.css('background-image') == "none" || show.css('background-image') == null || show.css('background-image') == undefined) {

                $('<img/>').attr('src', show.attr('data-bgitem')).load(function () {
                    show.css("background-image", "url('" + show.attr('data-bgitem') + "')");

                    playTimeline(hide, show);
                    isLoading = false;
                });
            }
            else {

                playTimeline(hide, show);

                isLoading = false;
            }
        }
    }


    return {
        init: init
    };
})();



IREP.homePageSubBanner = (function () {

    var startingPoint = $(".subBanner");
    var $subRows = $(".subHolder")
    var $subsToShow = 3;
    

    var init = function () {

        var offsetFromBottom = 220 - ($(window).height() - $("#subBanner").offset().top);

        if (offsetFromBottom > 0) {
            $("#subBanner").css("bottom", "+=" + offsetFromBottom);
        }
        var $i = 0;
        for (var i = 0; i < $subsToShow; i++) {
            $subRows.eq(i).css({ "display": "inline-block" });
        }
        $(".subHolder:visible").each(function () {
            scaleMyText($(this).find(".titleText").find('p'));
        });

        $(".subHolder").click(function () {
            window.open
            if ($(this).find("a").attr("target") == "blank") {
                window.open($(this).find("a").attr("href"));
            }
            else {
                window.location.href = $(this).find("a").attr("href");
            }

        });
        
        var intervalid = window.setInterval(function () { rotateSubBanners() }, 6000);

        $(".subHolder").hover(
            function () {
                window.clearInterval(intervalid);
                $(this).find('.hoverText').css("display", "table");
            },
            function () {
                intervalid = window.setInterval(function () { rotateSubBanners() }, 6000);
                $(this).find('.hoverText').css("display", "none");
            }
        );
        
        
        
    };

    // Keeping this in case the fix doesn't work
    //var scaleMyText = function (ctrl) {
    //    var height = ctrl.innerHeight() - 2 * ctrl.css("padding").replace("px", "");
    //    var width = ctrl.innerWidth() - 2 * ctrl.css("padding").replace("px", "");
    //    $("#spacer").width(width);
    //    $("#spacer").css("font-size", ctrl.css("font-size"));
    //    $("#spacer").css("line-height", ctrl.css("line-height"));
    //    $("#spacer").text(ctrl.text());
    //    if (parseInt(height) < parseInt($("#spacer").innerHeight())) {
    //        while (parseInt(height) < parseInt($("#spacer").innerHeight())) {
    //            $("#spacer").css("font-size", "-=1px");
    //            var lh = $("#spacer").css("line-height").replace("px", "") - 1;
    //            $("#spacer").css("line-height", lh + "px");
    //        }
    //        ctrl.css("font-size", $("#spacer").css("font-size"));
    //        ctrl.css("line-height", $("#spacer").css("line-height"));
    //    }
    //}

    var scaleMyText = function (ctrl) {
        
        var height = $(ctrl).css('height').replace("px", "");
        var width = $(ctrl).css('width').replace("px", "");
        var prheight = parseInt($(ctrl).parent('.titleText').css('height').replace("px", "")) - 20;
        
        if (parseInt(height) > prheight) {
            
            $(ctrl).css('font-size', '18px');
            
        }
    }

    var hideMeSub = function ($me) {
        $('.subHolder').css("right", "0");
        $me.css("display", "none");
    }

    var showMeSub = function ($me) {
        $me.css("display", "inline-block");
        scaleMyText($me.find(".titleText"));
        startingPoint.append($me);
    }


    var rotateSubBanners = function () {
        var subHolderContainer = $(".subBanner"),
            subHolders = subHolderContainer.find(".subHolder"),
            elementToMoveToEnd = $(subHolders.get(0)),
            elementToShow = $(subHolders.get($subsToShow % subHolders.length));
        var count = 1;

        // hide first so that if there's only $subsToShow, the item will be hidden then immediately shown at the end/right
        elementToMoveToEnd.css({ display: "none" });
        elementToShow.css({ display: "inline-block" });

        // appending actually moves the element in the dom, so this removes and adds
        subHolderContainer.append(elementToMoveToEnd);

        
    }

    return {
        init: init
    };
})();